<template>
    <div>
        <template v-if="order">
            <template v-if="discounts && discounts.length">
              <h5>Discounts</h5>
              <div v-for="(discount, index) in discounts" :key="index">
                <div class="basket-summary__product-row" >
                    <div class="basket-summary__product-title">
                        {{ discount.description }}
                    </div>
                    <div class="basket-summary__product-qty">
                        {{ discount.quantity }}
                    </div>
                    <div class="basket-summary__product-cost">
                        <product-price :price="discount.line_total / 100" :tax="discount.tax_total / 100" :discount="(discount.discount_total) / 100"></product-price>
                    </div>
                </div>
              </div>
            </template>
            <hr v-if="manualLines.length">
            <div class="row"  v-for="line in manualLines" :key="line.id">
              <div class="col-md-6">
                {{ line.description }}
              </div>
              <div class="col-md-1">
                <span v-if="line.quantity > 1">{{ line.quantity }}</span>
              </div>
              <div class="col-md-5 text-right">
                <product-price :price="line.line_total / 100" :tax="line.tax_total / 100"></product-price>
              </div>
              <div class="col-md-1" v-if="line.is_manual && !line.is_shipping">
                <a href="#" @click.prevent="removeLine(line.id)" class="text-danger"><i class="fa fa-times"></i></a>
              </div>
            </div>

            <div class="basket-summary__basket-totals">
              <div class="row basket-totals">
                <div class="col-xs-6">
                  Sub Total
                </div>
                <div class="col-xs-6 text-right basket-totals__value">
                  <small>&pound;</small>{{ order.sub_total|number_format(true) }}
                </div>
              </div>
              <div class="row basket-totals" v-if="shippingLines.length">
                <div class="col-xs-6">
                  Delivery
                </div>
                <div class="col-xs-6 text-right basket-totals__value">
                  <small>&pound;</small>{{ shippingTotal|number_format(true) }}
                </div>
              </div>
              <div class="row basket-totals">
                <div class="col-xs-6">
                  VAT Total
                </div>
                <div class="col-xs-6 text-right basket-totals__value">
                  <small>&pound;</small>{{ order.tax_total|number_format(true) }}
                </div>
              </div>

              <hr>

              <div class="row basket-totals basket-totals--total">
                <div class="col-xs-6">
                  Order Total
                </div>
                <div class="col-xs-6 text-right basket-totals__value">
                  <small>&pound;</small>{{ order.order_total|number_format(true) }}
                </div>
              </div>
            </div>

        </template>
    </div>
</template>

<script>
    import Order from '../../Services/Order.js';
    import Basket from '../../Services/Basket.js';
    import ProductPrice from '../Product/ProductPrice.vue';

    export default {
        components: {
            ProductPrice
        },
        data() {
            return {
                service: Order
            }
        },
        methods: {
            removeLine(lineId) {
              this.service.removeLine(lineId);
            }
        },
        computed: {
            additionalDelivery() {
              return Basket.additionalDelivery();
            },
            order() {
                return this.service.getOrder();
            },
            discounts() {
              return this.service.getDiscountLines();
            },
            subTotal() {
                return this.service.order.sub_total;
            },
            shippingLine() {
                return this.service.getShippingLine();
            },
            shippingLines() {
                return this.service.getShippingLines();
            },
            manualLines() {
              return this.service.getManualLines();
            },
            shippingTotal() {
              let total = 0;
              _.each(this.shippingLines, line => {
                total += line.line_total;
              });

              // if (this.additionalDelivery) {
              //   return ((total / 100) + this.additionalDelivery) * 100;
              // }
              return total;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Checkout/OrderSummary.vue